import React, { useEffect } from 'react'
import { Button, Checkbox, Col, message, Modal, Row, Select, Timeline, Tooltip } from 'antd'
import { YhForm } from '@/components/YhFormBoxVertical'
import { FormItemTypeEnum, IYhForm } from '@/components/YhFormBox/Types'
import { useDictModel } from '../assetsAskModel'
import useGlobalModel from '@/model/globalModel'
import { UserAddOutlined, UserDeleteOutlined } from '@ant-design/icons'
import { dictService } from '../assetsAskService'
import YhTootip from '@/components/YhTootip'
import { useOrgModel } from '../../organization/orgModel'
import { globalPrompt } from '@/components/message'

export const FormBox = () => {
    const {
        mode,
        setSelectedNodes,
        onSubmit,
        formVal,
        getOneData,
        setGetOneData,
        setFormVal,
        onChangeFormVal,
        getOneNameList,
        setGetOneNameList,
        selectedNodes,
        addUserVisible,
        setAddUserVisible,
        addUserData,
        setAddUserData,
        detialSelect,
        setDetialSelect,
        getOne,
        editUserData,
        setEditUserData
    } = useDictModel()
    const { treeSource: orgTreeSource, loadData: orgLoadData, setSelectedNodes: setorgSelectedNodes, selectedNodes: orgSelectedNodes, } = useOrgModel();
    const { userList } = useGlobalModel()
    const CheckboxGroup = Checkbox.Group
    const chengeCompany = async (value, options) => {
        setFormVal({
            ...formVal,
            departmentName: options.orgName,
            department: options.orgCode,
            user: options.label,
            userCode: options.code,
            // userCode: options.value,
        })
    }
    const newUserList = userList.map((item) => { return { ...item, value: item.label } })
    const controlsUser = () => {
        setAddUserVisible(true)
    }
    const deleteUser = (list) => {
        dictService.delectUser(list.id).then((res) => {
            getOne(selectedNodes[0].code)
            message.success('审批人删除成功!')
            setAddUserData({})
        })
    }
    const getName = async () => {
        if (formVal.name && getOneNameList.includes(formVal.name)) {
            globalPrompt("message", { text: "审批名称不可重复！", type: "warning" });
            setFormVal({ ...formVal, name: '' });
        }
    }
    const formConfig: IYhForm = {
        labelCol: { span: 8 },
        formValues: formVal,
        onChange: onChangeFormVal,
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '申请类型',
                fieldName: 'typeName',
                span: 13,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '审批名称',
                fieldName: 'name',
                span: 13,
                onInputBlur: getName,
                rules: [{ required: true, message: '该项为必填项' }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '所属部门',
                fieldName: 'departmentName',
                span: 13,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '审批人',
                fieldName: 'user',
                options: userList,
                onSelectChange: chengeCompany,
                span: 13,
                rules: [{ required: true, message: '该项为必填项' }],
            },
        ],
    }
    const changeStatus = (e: any) => {
        let newList: any = []
        getOneData[e].map((item) => {
            newList.push(item.id)
        })
        dictService.changeStatus({ idList: newList, typeCode: selectedNodes[0].code, unit: orgSelectedNodes[0].code ?? '', }).then((res) => {
            getOne(selectedNodes[0].code)
            message.success('状态修改成功!')
        })
    }
    return (
        <>
            <div className="dict-list-header" style={{ paddingBottom: '20px' }}>
                <span className="dict-from-title">{selectedNodes[0].name === '' ? '一级字典' : selectedNodes[0].name} </span>
            </div>
            {mode == 'add' && (
                <>
                    {' '}
                    <div>
                        <YhForm {...formConfig} />
                    </div>
                    <div style={{ float: 'right', marginTop: '25px', width: '55%', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                        <Button type="link" shape="round" onClick={() => onSubmit('add')}>
                            保存并新增
                        </Button>
                        <Button type="link" shape="round" onClick={() => onSubmit('finish')}>
                            保存
                        </Button>
                        <Button type="link" shape="round" onClick={() => setSelectedNodes([])}>
                            取消
                        </Button>
                    </div>
                </>
            )}
            {mode == 'look' && (
                <CheckboxGroup style={{ width: '100%' }} value={detialSelect.length > 0 ? detialSelect : []} >
                    {getOneNameList.map((item: string) => {
                        return (
                            <Col span={24} style={{ marginLeft: '50px' }}>
                                <Checkbox value={item} style={{ marginBottom: '10px' }} onClick={() => changeStatus(item)}>
                                    <span style={{ fontSize: '20px', fontWeight: 'bold' }}>{item}</span>
                                </Checkbox>
                                <Timeline >
                                    {getOneData[item] && getOneData[item].map((list: any) => {
                                        return (
                                            <Timeline.Item color="green" style={{ marginLeft: '50px' }} >
                                                <Row style={{ width: '700px' }}>
                                                    <Col style={{ width: '250px' }}>
                                                        <Tooltip placement="topLeft" title={list.departmentName}>
                                                            <span style={{ marginRight: '50px', fontSize: '18px' }} >{list.departmentName?.length > 10 ? list.departmentName.slice(0, 10) + '...' : list.departmentName}</span>
                                                        </Tooltip>
                                                    </Col>
                                                    <Col style={{ width: '140px' }}>
                                                        <span style={{ marginRight: '50px', fontSize: '18px', color: '#4949db', cursor: 'pointer' }} onClick={() => { controlsUser(); setEditUserData(list) }} >{list.user}</span>
                                                    </Col>
                                                    <Col style={{ width: '250px' }}>
                                                        <UserAddOutlined style={{ marginRight: '10px', color: 'green' }} onClick={() => { controlsUser(); setAddUserData(list) }} />
                                                        <UserDeleteOutlined style={{ color: 'red' }} onClick={() => deleteUser(list)} />
                                                    </Col>
                                                </Row>
                                            </Timeline.Item>
                                        )
                                    })}
                                </Timeline>
                            </Col>
                        )
                    })}
                </CheckboxGroup>)}
            <Modal
                title="添加审批人"
                visible={addUserVisible}
                width={600}
                onOk={() => onSubmit('addUser')}
                onCancel={() => {
                    setAddUserVisible(false)
                }}
            >
                <span>请选择审批人：</span>
                <Select
                    showSearch={true}
                    options={newUserList}
                    onChange={chengeCompany}
                />
            </Modal>
        </>
    )
}
